import moment from 'moment/moment';
import PoStatus from '../../Constants/purchase-order-status.ts';

const getPoStatus = ({
  revised_at,
  vendor_rejection_reason,
  revision_accepted_at,
}) => {
  if (vendor_rejection_reason) return PoStatus.PENDING;
  if (
    (!revision_accepted_at && revised_at) ||
    (revised_at && moment(revision_accepted_at).isBefore(revised_at))
  ) {
    return PoStatus.ACCEPT_REVISION;
  }

  // Return ACCEPTED as we're removing the ACCEPTANCE stage but keeping the REVISION mechanism.
  return PoStatus.ACCEPTED;
};

export default getPoStatus;
